module.exports = __webpack_public_path__ + "c_static/img/短信.2d7fab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/短信.png
// module id = oh/V
// module chunks = 33